export default "__VITE_ASSET__BtPhQsQW__"